// Common Client v2 imports
const { navigate } = require('client-v2/common/state/router/actions')

// URL helpers

function navigateToSearchQueryHref(hrefFunc) {
  // Creates a navigation action dispatcher from a href helper function
  return function ({ event, query }) {
    return function (dispatch) {
      dispatch(navigate({
        event,
        href: hrefFunc(query)
      }))
    }
  }
}

function searchQueryCollectionsHref(query) {
  return `/search/${query.encoded}/collections`
}

function searchQueryInterestsHref(query) {
  return `/search/${query.encoded}/interests`
}

function searchQueryPeopleHref(query) {
  return `/search/${query.encoded}/people`
}

function searchQueryPostsHref(query) {
  return `/search/${query.encoded}`
}

module.exports = {
  // URL helpers
  searchQueryCollectionsHref,
  searchQueryInterestsHref,
  searchQueryPeopleHref,
  searchQueryPostsHref
}

// Define and export navigation dispatchers
Object.entries({
  navigateToSearchQueryCollections: searchQueryCollectionsHref,
  navigateToSearchQueryInterests: searchQueryInterestsHref,
  navigateToSearchQueryPeople: searchQueryPeopleHref,
  navigateToSearchQueryPosts: searchQueryPostsHref
}).forEach(([ key, value ]) => {
  module.exports[key] = navigateToSearchQueryHref(value)
})
